import React, { Component } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { Modal } from 'react-bootstrap';
import './_desktopSetupLoaderModalModal.scss';

export default class DesktopSetupLoaderModal extends Component {
  render() {
    const { isModalVisible, isPaymentError = false } = this.props;
    return (
      <div>
        <Modal show={isModalVisible} size="lg" centered>
          <div className="desktop-setup-purchase">
            {isPaymentError ? (
              <div>
                <div className="cancel-purchase-title">OOPS!</div>

                <div className="cancel-purchase-rewards">
                  <div className="cancel-purchase-not-leaving">
                    It seems something went wrong, please retry
                  </div>
                  <div>
                    <img src="/images/block.svg" alt="block" />
                  </div>
                  <button>Retry</button>
                </div>
              </div>
            ) : (
              <div>
                <div className="cancel-purchase-title">SAVINGS PLAN SETUP</div>

                <div className="cancel-purchase-rewards">
                  <div className="cancel-purchase-not-leaving">
                    This may take a few minutes, please do not referesh or close this tab.
                  </div>
                  <div>
                    <Player
                      autoplay
                      loop
                      keepLastFrame
                      src="https://assets6.lottiefiles.com/packages/lf20_5xjxnhli.json"
                      className="sand-clock"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}
